import { ApplyFileStatusType } from '../ApplicationConstants';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faTimes } from '@fortawesome/free-solid-svg-icons';

export const getFileStatusColumnHtml = (status: ApplyFileStatusType, isNotApplicable = false) => {
    switch (isNotApplicable ? ApplyFileStatusType.NotApplicable : status) {
        case ApplyFileStatusType.NotApplicable:
            return 'n/a';
        case ApplyFileStatusType.No:
            return (
                <b>
                    <i className='red-text'>
                        <FontAwesomeIcon icon={faTimes} />
                    </i>
                </b>
            );
        case ApplyFileStatusType.Pending:
            return <span className='blue-text'>Pending</span>;
        case ApplyFileStatusType.Approved:
            return (
                <b>
                    <i className='green-text'>
                        <FontAwesomeIcon icon={faCheck} />
                    </i>
                </b>
            );
        case ApplyFileStatusType.Rejected:
            return <span className='red-text'>Rejected</span>;
        default:
            return '';
    }
};
